import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const ShopCtx = createContext(null);
export const useShop = () => useContext(ShopCtx);

const RATES = { EUR: 1, GBP: 0.86 };
const SYMBOLS = { EUR: "€", GBP: "£" };

export function ShopProvider({ children }) {
  const [cart, setCart] = useState(() => JSON.parse(localStorage.getItem("bm_cart") || "[]"));
  const [wishlist, setWishlist] = useState(() => JSON.parse(localStorage.getItem("bm_wish") || "[]"));
  const [recentlyViewed, setRecentlyViewed] = useState(() => JSON.parse(localStorage.getItem("bm_recent") || "[]"));
  const [currency, setCurrencyState] = useState(localStorage.getItem("bm_ccy") || "EUR");
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => localStorage.setItem("bm_cart", JSON.stringify(cart)), [cart]);
  useEffect(() => localStorage.setItem("bm_wish", JSON.stringify(wishlist)), [wishlist]);
  useEffect(() => localStorage.setItem("bm_recent", JSON.stringify(recentlyViewed)), [recentlyViewed]);
  useEffect(() => localStorage.setItem("bm_ccy", currency), [currency]);

  const addToCart = (product, qty = 1) => {
    setCart(prev => {
      const found = prev.find(i => i.product_id === product.id);
      if (found) return prev.map(i => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      return [...prev, { product_id: product.id, name: product.name, price: product.price, image: product.images?.[0], slug: product.slug, quantity: qty }];
    });
    setCartOpen(true);
  };
  const updateQty = (product_id, quantity) => {
    if (quantity <= 0) return removeFromCart(product_id);
    setCart(prev => prev.map(i => i.product_id === product_id ? { ...i, quantity } : i));
  };
  const removeFromCart = (product_id) => setCart(prev => prev.filter(i => i.product_id !== product_id));
  const clearCart = () => setCart([]);

  const toggleWishlist = (product) => {
    setWishlist(prev => prev.find(p => p.id === product.id) ? prev.filter(p => p.id !== product.id) : [...prev, product]);
  };
  const isWishlisted = (id) => wishlist.some(p => p.id === id);

  const trackView = (product) => {
    setRecentlyViewed(prev => {
      const filtered = prev.filter(p => p.id !== product.id);
      return [product, ...filtered].slice(0, 6);
    });
  };

  const setCurrency = (c) => setCurrencyState(c);
  const format = (eurAmount) => {
    const v = eurAmount * RATES[currency];
    return `${SYMBOLS[currency]}${v.toFixed(2)}`;
  };

  const cartCount = cart.reduce((s, i) => s + i.quantity, 0);
  const cartSubtotal = cart.reduce((s, i) => s + i.price * i.quantity, 0);

  const value = useMemo(() => ({
    cart, addToCart, updateQty, removeFromCart, clearCart, cartCount, cartSubtotal,
    wishlist, toggleWishlist, isWishlisted,
    recentlyViewed, trackView,
    currency, setCurrency, format,
    cartOpen, setCartOpen,
  }), [cart, wishlist, recentlyViewed, currency, cartOpen]);

  return <ShopCtx.Provider value={value}>{children}</ShopCtx.Provider>;
}
